import {useQuery} from '@tanstack/react-query';
import {fetch} from '../services/ReconciliationReportsService';
import {reconciliationReportsKeys} from './useReconciliationReports.ts';

// FNP-535: single-record read for the detail view. Read-only — no create, update,
// or delete mutations (the ChannelReconciler owns the lifecycle).
export const useReconciliationReport = (reportId?: string) => {

    const reportQuery = useQuery({
        queryKey: reconciliationReportsKeys.detail(reportId),
        queryFn: () => fetch(reportId!),
        enabled: !!reportId,
        // A finished run does not change; see the list hook for why 30s.
        staleTime: 30_000,
    });

    return {
        record: reportQuery.data,
        loading: reportQuery.isLoading,
        // A failed load and a missing record are different states (§13): the detail
        // page labels them differently. The id is composite —
        // `reconciliation-report:{channel}#{runDate}` — so a mis-encoded id would not
        // resolve; see detailPath in config.
        isError: reportQuery.isError,
        notFound: reportQuery.isFetched && !reportQuery.isError && !reportQuery.data,
        fetchRecord: reportQuery.refetch,
    };
};
